import React from 'react';
import {
    Button,
    Popover,
    PopoverContent,
    PopoverTrigger,
    Stack,
    useDisclosure,
} from '@chakra-ui/react';
import { PopoverIcon } from './PopoverIcon';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { useGlobalContext } from '../../context/GlobalContext';

export const DocumentPopover = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const navigate = useNavigate(); // Initialize useNavigate

    const [{ config }] = useGlobalContext();

    const handleNavigation = (route) => {
        if (!config?.inOperation) {
            console.log("inOperation:", config?.inOperation);
            navigate(route); // Navigate to the specified route
            onClose(); // Close the popover after navigation
        } else {
            alert('Esta en operación activa, termine la operación para poder acceder a esta sección');
        }
    };


    const menuItems = [
        //{ label: 'Embarques', route: '/embarques' },
        { label: 'Etiqueta', route: '/list-printed-tags' },
        { label: 'Operaciones', route: '/list-operations' },
    ];

    return (
        <Popover isOpen={isOpen} onOpen={onOpen} onClose={onClose} trigger="hover" openDelay={0}>
            <PopoverTrigger>
                <Button rightIcon={<PopoverIcon isOpen={isOpen} />}>Reportes</Button>
            </PopoverTrigger>
            <PopoverContent marginLeft="150px" p="2" maxW="fit-content">
                <Stack spacing="0" alignItems="stretch">
                    {menuItems.map((item) => (
                        <Button
                            key={item.label}
                            variant="tertiary"
                            justifyContent="start"
                            onClick={() => handleNavigation(item.route)} // Navigate on click
                        >
                            {item.label}
                        </Button>
                    ))}
                </Stack>
            </PopoverContent>
        </Popover>
    );
};
